/* eslint-disable no-magic-numbers */
export class ClinicalFeedbackConstants {
    public static readonly CANNOT_SEARCH_STUDY_MESSAGE =
        'Please provide the MRN or the Accession number or at least 3 parameters to begin searching.';
    public static readonly SEARCH_ORDER_OVER_LIMIT_MESSAGE =
        'There are more than 100 orders matching the criteria. Please enter more specific search parameters.';
    public static readonly NO_DEFAULT_FEEDBACK = 'No study available to display.';
    public static readonly NO_ORDER_SEARCH_RESULT = 'No matching results found, please refine your search and try again.';
    public static readonly ORDER_WITHOUT_REGION_MESSAGE = 'Unable to raise feedback for this order as it does not have a region.';
    public static readonly DOWNLOAD_DOCUMENT_ERROR_MSG = 'There is an error in downloading the document, please contact support';

    public static readonly CLINICAL_FEEDBACK_DASHBOARD_PATH = 'clinical-feedback';

    public static readonly VALIDATOR_MAX_LENGTH_10000 = 10000;
    public static readonly VALIDATOR_MAX_LENGTH_256 = 256;
    public static readonly VALIDATOR_MAX_LENGTH_128 = 128;
    public static readonly VALIDATOR_MAX_LENGTH_64 = 64;
    public static readonly VALIDATOR_MAX_LENGTH_32 = 32;
    public static readonly VALIDATOR_MAX_LENGTH_15 = 15;
    public static readonly VALIDATOR_MAX_LENGTH_PHONE_EXTENSION = 8;

    public static readonly Kilobyte = 1024;
    public static readonly MAX_SINGLE_FILE_UPLOAD_SIZE = 250 * this.Kilobyte * this.Kilobyte;
    public static readonly MAX_FILE_AMOUNT = 20;
    // errorCode values the API returns when it rejects an attachment: an extension that isn't allowed,
    // or a file whose declared type or content doesn't match its extension.
    public static readonly FILE_TYPE_ERROR_CODES = ['InvalidExtension'];
    public static readonly FILE_CONTENT_ERROR_CODES = ['InvalidContentType', 'InvalidContent'];

    // This regex has problem with \-.
    public static readonly NAME_PATTERN = "[a-zA-ZÀ-ž\u0370-\u03FF\u0400-\u04FF][0-9a-zA-ZÀ-ž\u0370-\u03FF\u0400-\u04FF,.@'-_^ ]*";
    public static readonly MRN_PATTERN = '^[^\\\\]*$'; // This regex matches everything except a backslash.

    public static readonly FULL_PHONE_PATTERN = /^[+ ]?[\d ]*((ext|x)[\d ]+)?$/;
    public static readonly PHONE_PATTERN = /^[+ ]?[\d ]+$/;
    public static readonly PHONE_EXTENSION_PATTERN = /^[\d ]+$/;

    public static readonly ERROR_MESSAGE_REQUIRED = 'This field is required.';

    public static readonly HTTP_TIMEOUT_MSECONDS = 20000;

    public static readonly IMAGES_ARCHIVED_AFTER_DAYS = 45;

    public static readonly EMPTY_VALUE = '\u2014';
}
